<template>
  <div class="mb-md-5 mb-2">
    <div class="sub-title mb-2">Offertes</div>
    <div class="card card-table">
      <div class="card-body p-0">
        <table v-if="quotations" class="table table-hover table-orders">
          <thead>
            <tr>
              <th colspan="2" scope="col">Projectreferentie</th>
              <th class="text-right" scope="col">Offertedatum</th>
              <th scope="col">Bedrag (Ex. BTW)</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <template v-if="quotations.length">
              <tr v-for="quotation in quotations" :key="quotation.id" @click="loadQuotation(quotation)" class="cursor-pointer">
                <td class="order-id">
                  #{{ quotation.id }}
                </td>
                <td class="order-reference">
                  {{ quotation.reference }}
                </td>
                <td class="order-date text-right">{{ quotation.updated_at }}</td>
                <td v-html="quotation.totalPrice"></td>
                <td>
                  <div class="order-actions">
                    <span v-b-tooltip.hover.d200 title="Download">
                      <font-awesome-icon class="font-awesome-icon" v-if="isDownloadingOrder" icon="spinner" spin/>
                      <font-awesome-icon class="font-awesome-icon" v-else v-on:click.stop.prevent="download(quotation)" icon="arrow-circle-down"/>
                    </span>
                    <span v-b-tooltip.hover.d200 title="Kopiëren">
                      <font-awesome-icon class="font-awesome-icon" v-on:click.stop.prevent="copy(quotation)" icon="copy"/>
                    </span>
                    <span v-b-tooltip.hover.d200 title="Verwijderen">
                      <font-awesome-icon class="font-awesome-icon" v-on:click.stop.prevent="deleteQuotation(quotation)" icon="trash-alt"/>
                    </span>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else-if="!loadingQuotations">
              <tr>
                <td colspan="5">
                  Geen offertes gevonden.
                </td>
              </tr>
            </template>
          </tbody>
        </table>

        <div v-if="loadingQuotations" class="loading-orders text-center">
          <font-awesome-icon class="font-awesome-icon" icon="spinner" spin/>
        </div>
      </div>

      <div class="card-footer card-table-footer text-center">
        <div v-if="hasMoreQuotations" @click="loadMore" class="load-more">
          <font-awesome-icon class="font-awesome-icon" icon="plus-circle"/>
          Meer laden
        </div>
        <div v-else>
          Geen andere offertes om te laden
        </div>
      </div>
    </div>

    <b-modal ref="delete-quotation-modal" id="delete-quotation-modal" footer-class="modal-footer modal-delete-quotation" centered>
      <template slot="modal-header">
        <h4 class="modal-title">Let op!</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">
        <div class="col-md-13">
          Weet je zeker dat je deze offerte wilt verwijderen?
        </div>
      </template>

      <template slot="modal-footer">
        <button
          @click="hideModal"
          type="button"
          class="btn btn-round">Annuleren
        </button>
        <button
          @click="confirmDeleteQuotation"
          type="button"
          class="btn btn-oldevuuren btn-round">Verwijderen
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { CLEAR_QUOTATIONS, COPY_QUOTATION, DELETE_QUOTATION, DOWNLOAD_ORDER, FETCH_QUOTATIONS, LOAD_QUOTATION, SEARCH_QUOTATIONS } from '../../store/types'

  export default {
    props: ['search'],
    data() {
      return {
        offset: 0,
        quotationToDelete: null
      }
    },
    methods: {
      loadMore() {
        this.offset += 5
        // Fetch more quotations
        this.$store.dispatch(FETCH_QUOTATIONS, {
          search: this.search,
          offset: this.offset
        })
      },
      loadQuotation(quotation) {
        this.$store.dispatch(LOAD_QUOTATION, quotation)
      },
      download(quotation) {
        this.$store.dispatch(DOWNLOAD_ORDER, quotation.id)
      },
      copy(quotation) {
        this.$store.dispatch(COPY_QUOTATION, quotation)
      },
      deleteQuotation(quotation) {
        this.quotationToDelete = quotation
        this.$refs['delete-quotation-modal'].show()
      },
      confirmDeleteQuotation() {
        this.$store.dispatch(DELETE_QUOTATION, this.quotationToDelete)
        this.hideModal()
      },
      hideModal() {
        this.$refs['delete-quotation-modal'].hide()
      }
    },
    watch: {
      search() {
        this.$store.dispatch(SEARCH_QUOTATIONS, {
          search: this.search,
          offset: 0
        })
      }
    },
    computed: {
      quotations() {
        return !this.$store.getters.quotations ? [] : this.$store.getters.quotations
      },
      loadingQuotations() {
        return this.$store.getters.loadingQuotations
      },
      isDownloadingOrder() {
        return this.$store.getters.isDownloadingOrder
      },
      hasMoreQuotations() {
        return this.$store.getters.hasMoreQuotations
      }
    },
    created() {
      this.$store.dispatch(CLEAR_QUOTATIONS)
      this.$store.dispatch(FETCH_QUOTATIONS, {
        search: this.search,
        offset: this.offset
      })
    }
  }
</script>

<style lang="scss" scoped>
  .order-actions {
    span {
      margin-right: 5px;

      .font-awesome-icon {
        font-size: 1.1em;

        &:hover {
          color: $dark-grey;
        }
      }
    }
  }
</style>
